/**
 * Shorten a region name for a chip.
 *
 * The API returns full administrative names — «Андижанская область»,
 * «Кашкадарьинская область», `Andijon viloyati`. In a horizontally scrolling
 * chip strip the shared suffix is pure noise: every chip carries it, so it
 * distinguishes nothing while roughly doubling each chip's width and pushing
 * the rest of the regions off-screen.
 *
 * Only the redundant suffix goes. Names that carry meaning without one are
 * left exactly as they are — «Республика Каракалпакстан» and the city of
 * «Ташкент» are not «… область» and must not be trimmed to something that
 * reads as a different place.
 */
const SUFFIXES = [
  // ru
  /\s+область$/iu,
  // uz — both apostrophe forms in the wild (U+02BB is the correct one, but the
  // ASCII variant appears in older rows), plus the bare stem.
  /\s+viloyati$/iu,
  /\s+vilo[yʻ']ati$/iu,
];

export function regionChipLabel(name: string): string {
  for (const re of SUFFIXES) {
    const short = name.replace(re, '');
    if (short !== name) return short.trim();
  }
  return name;
}
